/**
 * Capa de Retroalimentación de Audio
 * Sintetiza tonos mediante Web Audio API en tiempo real sin requerir archivos externos.
 * Cumple con .idx-rules.md.
 */

let audioCtx = null;

/**
 * Inicializa el contexto de audio si no ha sido creado.
 * Razón: Las políticas de navegadores requieren interacción del usuario para reproducir sonido.
 */
function initAudio() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (audioCtx.state === 'suspended') {
    audioCtx.resume();
  }
}

/**
 * Genera un tono de corta duración.
 */
function playTone(freq, type, duration, delay = 0) {
  initAudio();
  const osc = audioCtx.createOscillator();
  const gain = audioCtx.createGain();

  osc.type = type;
  osc.frequency.setValueAtTime(freq, audioCtx.currentTime + delay);
  
  // Rampa de volumen para evitar ruidos bruscos al terminar
  gain.gain.setValueAtTime(0.15, audioCtx.currentTime + delay);
  gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + delay + duration);

  osc.connect(gain);
  gain.connect(audioCtx.destination);
  
  osc.start(audioCtx.currentTime + delay);
  osc.stop(audioCtx.currentTime + delay + duration);
}

/**
 * Sonido de Acceso Permitido (Tono ascendente)
 */
export function playSuccessChime() {
  try {
    playTone(587.33, 'sine', 0.1, 0); // D5
    playTone(880.00, 'sine', 0.15, 0.08); // A5
  } catch (error) {
    console.warn('No se pudo reproducir audio:', error);
  }
}

/**
 * Sonido de Acceso VIP / Cliente Frecuente (Triple tono alegre)
 */
export function playVipChime() {
  try {
    playTone(523.25, 'triangle', 0.08, 0); // C5
    playTone(659.25, 'triangle', 0.08, 0.08); // E5
    playTone(783.99, 'triangle', 0.12, 0.16); // G5
  } catch (error) {
    console.warn('No se pudo reproducir audio:', error);
  }
}

/**
 * Sonido de Rechazo (Zumbador grave y largo)
 */
export function playErrorBuzzer() {
  try {
    playTone(130.81, 'sawtooth', 0.35, 0); // C3
  } catch (error) {
    console.warn('No se pudo reproducir audio:', error);
  }
}
